/* VYBE — czat-doradca zapachów. Darmowy „mózg” w przeglądarce (bez serwera, bez kluczy):
   - rozumie zwykłe zdania: okazja, pora, dla kogo, klimat, nuty („z wanilią”, „bez słodkich”, „nie za mocny”), odmianę słów;
   - pamięta preferencje w rozmowie („a coś świeższego?”, „inny”), porównuje dwa zapachy, opisuje zapach, odpowiada na FAQ;
   - wszystko z danych sklepu (metapola vybe.*: nuty, akordy, okazje, styl, „lubisz”, klimat, profil 1–5).
   Opcjonalnie AI: gdy data-ai ma adres serwera, pytania, których mózg nie rozumie, idą do niego ({odpowiedz, polecane}). */
(() => {
  const root = document.querySelector('[data-vyd]');
  if (!root || root.dataset.vydGotowy) return;
  root.dataset.vydGotowy = '1';
  let D;
  try { D = JSON.parse(root.querySelector('[data-vyd-dane]').textContent); } catch (e) { return; }
  const ZAP = (D.zapachy || []).filter((z) => z && z.nr);
  if (!ZAP.length) return;
  root.hidden = false;

  const $ = (s) => root.querySelector(s);
  const okno = $('[data-vyd-okno]'), rozmowa = $('[data-vyd-rozmowa]'), pole = $('[data-vyd-pole]'), input = pole.querySelector('input');
  const dymek = $('[data-vyd-otworz]');
  const AI = (root.dataset.ai || '').trim();
  const esc = (t) => String(t ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const bez = (t) => String(t || '').toLowerCase().replace(/ł/g, 'l').normalize('NFD').replace(/[̀-ͯ]/g, '');
  const lista = (v) => (Array.isArray(v) ? v : []);
  const cena = ZAP.find((z) => z.cena)?.cena || '';
  const sesja = { get: (k) => { try { return sessionStorage.getItem(k); } catch (e) { return null; } }, set: (k, v) => { try { sessionStorage.setItem(k, v); } catch (e) {} } };
  const nuty = (z) => [...lista(z.nuty?.gora), ...lista(z.nuty?.serce), ...lista(z.nuty?.baza)];
  const PROFIL = { slodycz: 'słodycz', swiezosc: 'świeżość', cieplo: 'ciepło', wyrazistosc: 'wyrazistość' };

  /* ——— wiedza ze sklepu (FAQ, polityki) ——— */
  const FAQ = {
    coto: `To perfumy w stałej formie — kremowy balsam zamknięty w małej kostce. Nakładasz je palcem prosto na skórę, bez sprayu. Nic się nie rozleje i nic się nie stłucze, więc nosisz je w kieszeni albo w torebce.`,
    uzycie: `Przeciągnij palcem po balsamie i nałóż na nadgarstki, szyję albo za uszy — tam, gdzie skóra jest najcieplejsza, zapach rozchodzi się najlepiej. Kostka jest mała, więc w ciągu dnia łatwo poprawisz zapach.`,
    trwalosc: `To zależy od skóry i od samego zapachu — słodkie i drzewne kompozycje czuć zwykle dłużej niż świeże. Kostka mieści się w kieszeni, więc łatwo poprawisz zapach w ciągu dnia.`,
    feromony: `Tak producent opisuje formułę — to dodatek w składzie. Nie obiecujemy cudów: najważniejszy jest zapach, który lubisz i w którym dobrze się czujesz.`,
    dostawa: `Dostępne opcje i koszt dostawy zobaczysz w kasie, zanim zapłacisz. Szczegóły są w <a href="/policies/shipping-policy">polityce wysyłki</a>.`,
    zwroty: `Masz 14 dni na odstąpienie od umowy bez podawania przyczyny. Szczegóły znajdziesz w <a href="/policies/refund-policy">polityce zwrotów</a>.`,
    cena: `Każdy zapach VYBE kosztuje ${esc(cena)}. Za cenę jednego flakonu z perfumerii możesz mieć kilka zapachów na różne okazje.`,
    ile: `Mamy ${ZAP.length} kompozycji — od świeżych na dzień po ciepłe i słodkie na wieczór. Każda ma swój numer.`,
    zamowienie: `W sprawie złożonego zamówienia najszybciej pomożemy przez <a href="${esc(D.kontakt)}">formularz kontaktowy</a> — podaj numer zamówienia.`,
    popularny: `Nie pokazuję rankingu sprzedaży, ale dobiorę zapach pod ciebie — to lepsze niż najpopularniejszy.`,
  };

  /* ——— słowa i dopasowanie mimo odmiany ——— */
  const STOP = new Set('i z ze na do w we bez nie cos jak ale za mi mnie sie to ten ta te czy dla od lub albo bardzo troche raczej zapach zapachy zapachu perfumy perfum chce chcialbym chcialabym szukam polec polecisz polecasz jakis jakies jakas mam lubie moze byc by jest sa o po a no tak jaki jaka jakie nuty nuta nutami'.split(' '));
  const tokeny = (t) => bez(t).split(/[^a-z0-9]+/).filter(Boolean);
  const podobne = (a, b) => {
    if (a === b) return true;
    const n = Math.min(a.length, b.length);
    if (n < 4) return n === 3 && (a.startsWith(b) || b.startsWith(a)) && Math.max(a.length, b.length) <= 4;
    const k = Math.max(4, Math.min(5, n - 1));
    return a.slice(0, k) === b.slice(0, k);
  };
  // słownik nut każdego zapachu: [słowo, waga, oryginalna nazwa]
  const SLOWNIK = new Map(ZAP.map((z) => {
    const w = [];
    const dodaj = (fraza, waga) => tokeny(fraza).filter((s) => !STOP.has(s) && s.length >= 3).forEach((s) => w.push([s, waga, fraza]));
    lista(z.akordy).forEach(([n, sila]) => dodaj(n, 15 + (sila || 50) * 0.45));
    nuty(z).forEach((n) => dodaj(n, 45));
    lista(z.lubisz).forEach((n) => dodaj(n, 35));
    lista(z.styl).forEach((n) => dodaj(n, 40));
    return [z.nr, w];
  }));

  /* ——— rozpoznawanie intencji ——— */
  const TAB = {
    okazja: [[/randk|kolacj|walentyn|romant|dziewczyn|chlopak|we dwoje|zony|meza/, 'randka'], [/prac|biur|spotkan|rozmow|szkol|uczelni|egzamin|prezentacj/, 'praca'],
      [/impre|klub|domowk|wyjsc|bar\b|koncert|sylwest|party|osiemnast/, 'impreza'], [/wesel|slub|komuni|chrzest|gala|garnitur|wyjatkow|specjaln/, 'wesele'],
      [/wakac|plaz|urlop|morze|upal|wyjazd|podroz/, 'wakacje'], [/silown|trening|sport|codzien|na co dzien|uniwersal|zawsze|kazd/, 'codzien'],
      [/prezent|upomin|urodzin|imienin|swiet|mikolaj|dla tat|dla mam|dla brat|dla siostr|dla przyjaci/, 'prezent']],
    pora: [[/rano|w dzien|na dzien|dzienn|poranek/, 'dzien'], [/wieczor|noc|wieczorem/, 'wieczor'], [/zim|jesien|chlodn|zimn|mroz/, 'zima'], [/lato|letni|wiosn|gorac|upal/, 'lato']],
    dla: [[/dla (niej|dziewczyn|kobiet|zon|mam|siostr|pani|corki|babci|przyjaciolk|cioc)|damsk/, 'f'], [/dla (niego|chlopak|facet|mez|tat|brat|pana|syn|dziadk|kumpl|przyjaciel)|mesk|facet|z dziewczyn|z zona|z partnerk/, 'm'], [/unisex|obojetn|dla kazdego|dla obojga/, 'u']],
  };
  const KLIMATY = [[/slodk|deser|cukier|lakoc/, 'slodki'], [/swiez|cytrus|morsk|czyst|orzezw|lekk|wodn/, 'swiezy'], [/drzewn|dym|tyto|skor|ciemn|orient/, 'drzewny'],
    [/owoc|wisni|ananas|porzecz/, 'owocowy'], [/mocn|wyrazist|intensyw|ciezk|gest|zmyslow/, 'mocny'], [/delikat|subteln|lagodn|nienachal|dyskret|mniej intensyw/, 'delikatny'],
    [/ciepl|otulaj|przytuln|kominek/, 'cieply']];
  const NEGACJA = /^(nie|bez|unikam|nienawidze|mniej|zadnych|zadnej)$/;
  const znajdz = (t, tab) => (tab.find(([re]) => re.test(t)) || [])[1];

  // preferencje z jednej wiadomości (z przeczeniami)
  const czytaj = (tekst) => {
    const t = bez(tekst), tk = tokeny(tekst);
    const p = { okazja: znajdz(t, TAB.okazja), pora: znajdz(t, TAB.pora), dla: znajdz(t, TAB.dla), klimat: {}, nuty: [], slowa: tk };
    tk.forEach((s, i) => {
      const neg = [tk[i - 1], tk[i - 2]].some((x) => x && NEGACJA.test(x)) || (tk[i - 1] === 'za' && tk[i - 2] === 'nie');
      KLIMATY.forEach(([re, k]) => { if (re.test(s)) p.klimat[k] = neg ? -1 : 1; });
      if (!STOP.has(s) && s.length >= 3) p.nuty.push({ s, neg });
    });
    if (/nie za slodk|mniej slodk|bez slodk|nie slodk|nie lubie slodk/.test(t)) p.klimat.slodki = -1;
    return p;
  };
  const maSygnal = (p) => !!(p.okazja || p.pora || p.dla || Object.keys(p.klimat).length || trafNuty(p).length);
  const trafNuty = (p) => p.nuty.filter((n) => ZAP.some((z) => SLOWNIK.get(z.nr).some(([w]) => podobne(n.s, w))));

  /* ——— ranking ——— */
  const OKAZJE = {
    randka: ['randka', 'wieczor we dwoje', 'kolacja'], praca: ['praca', 'spotkanie biznesowe', 'wazne spotkanie', 'na co dzien'],
    impreza: ['impreza', 'klub', 'wieczorne wyjscie', 'wieczor w miescie', 'wieczor w barze', 'wieczor z przyjaciolkami'],
    wesele: ['wesele', 'okazje specjalne', 'kolacja'], wakacje: ['wakacje', 'plaza', 'miasto latem', 'lato w miescie', 'wyjazd'],
    codzien: ['na co dzien', 'praca', 'po treningu'], prezent: [],
  };
  // słowa klienta → słowa z okazji w sklepie (dokładne trafienie waży więcej niż ogólna kategoria)
  const SYNONIMY = { silownia: 'trening', silowni: 'trening', silownie: 'trening', sport: 'trening', sportu: 'trening', biuro: 'praca', biura: 'praca', biurze: 'praca',
    pracy: 'praca', prace: 'praca', slub: 'wesele', slubie: 'wesele', weselu: 'wesele', urlop: 'wakacje', morze: 'plaza', morza: 'plaza', plaze: 'plaza',
    bar: 'barze', baru: 'barze', domowke: 'impreza', domowka: 'impreza', imprezy: 'impreza', imprezke: 'impreza', klubu: 'klub', kolacje: 'kolacja', randke: 'randka', randki: 'randka' };
  const OGOLNE = new Set(['na', 'co', 'w', 'z', 'we', 'po', 'dzien', 'wieczor', 'wieczorne']);
  const OKAZJE_SLOWA = new Map(ZAP.map((z) => [z.nr, lista(z.okazje).map((o) => tokeny(o).filter((s) => !OGOLNE.has(s)))]));
  const punkty = (z, p) => {
    let s = 0;
    const ok = lista(z.okazje).map(bez), pora = z.pora || '', pr = z.profil || {}, plec = bez(z.plec || 'unisex');
    const slowa = (p.slowa || []).map((w) => SYNONIMY[w] || w);
    const wprost = OKAZJE_SLOWA.get(z.nr).filter((ws) => ws.length && ws.some((w) => slowa.some((q) => podobne(q, w)))).length;
    s += Math.min(2, wprost) * 170;
    if (p.okazja && OKAZJE[p.okazja]) s += Math.min(2, OKAZJE[p.okazja].filter((k) => ok.includes(k)).length) * 80;
    if (p.okazja === 'wakacje' && (pora.includes('lato') || pora.includes('cały rok'))) s += 60;
    if ((p.okazja === 'randka' || p.okazja === 'impreza') && pora.includes('wieczór')) s += 40;
    if (p.okazja === 'praca' && pora.includes('dzień')) s += 40;
    if (p.okazja === 'prezent') { if (plec === 'unisex') s += 50; if (pora.includes('cały rok')) s += 50; if (lista(z.styl).map(bez).includes('uniwersalny')) s += 60; }
    if (p.pora === 'dzien' && pora.includes('dzień')) s += 70;
    if (p.pora === 'wieczor' && pora.includes('wieczór')) s += 70;
    if (p.pora === 'zima' && (pora.includes('zima') || pora.includes('cały rok'))) s += 70;
    if (p.pora === 'lato' && (pora.includes('lato') || pora.includes('cały rok'))) s += 70;
    const k = p.klimat || {};
    const os = { slodki: (pr.slodycz || 0) * 24, swiezy: (pr.swiezosc || 0) * 24, drzewny: ((pr.cieplo || 0) + (pr.wyrazistosc || 0)) * 11, owocowy: 0,
      mocny: (pr.wyrazistosc || 0) * 22, delikatny: (6 - (pr.wyrazistosc || 3)) * 18, cieply: (pr.cieplo || 0) * 22 };
    if (k.owocowy) os.owocowy = lista(z.akordy).filter(([n]) => /owoc|wiśn|tropik|cytrus/.test(n)).reduce((a, [, w]) => a + w, 0) * 0.9;
    // „nie słodkie” = kara względem środka skali (słodycz 1 dostaje plus, 5 duży minus), a nie zerowanie wszystkiego
    const srodek = { slodki: 2.5 * 24, swiezy: 2.5 * 24, drzewny: 5 * 11, owocowy: 0, mocny: 2.5 * 22, delikatny: 3 * 18, cieply: 2.5 * 22 };
    Object.entries(k).forEach(([nazwa, znak]) => { s += znak > 0 ? os[nazwa] * znak : -(os[nazwa] - srodek[nazwa]) * 1.2; });
    const slow = SLOWNIK.get(z.nr);
    (p.nuty || []).forEach(({ s: q, neg }) => {
      const traf = slow.filter(([w]) => podobne(q, w));
      if (traf.length) { const waga = Math.max(...traf.map(([, wg]) => wg)); s += neg ? -waga * 1.4 : waga * 1.5; }
    });
    if (p.dla === 'm') s += plec === 'damskie' ? -500 : plec === 'meskie' ? 40 : 25;
    if (p.dla === 'f') s += plec === 'meskie' ? -500 : plec === 'damskie' ? 60 : 30;
    if (p.dla === 'u') s += plec === 'unisex' ? 90 : 0;
    if (p.wzgledem) { const d = ((pr[p.wzgledem.cecha] || 0) - p.wzgledem.od) * p.wzgledem.kier; s += d > 0 ? 160 + d * 40 : -400; }
    if (p.podobny) { // podobny = najbliższy charakter (profil 1–5) + wspólne nuty i akordy + ta sama „płeć” zapachu
      const w = ZAP.find((x) => x.nr === p.podobny), pw = w.profil || {};
      s += 220 - Object.keys(PROFIL).reduce((a, k) => a + Math.abs((pr[k] || 0) - (pw[k] || 0)), 0) * 35;
      const ww = new Set(SLOWNIK.get(w.nr).map(([x]) => x));
      s += Math.min(6, [...new Set(SLOWNIK.get(z.nr).map(([x]) => x))].filter((x) => ww.has(x)).length) * 18;
      if (bez(w.plec) === plec || plec === 'unisex') s += 30;
    }
    return s;
  };
  const ranking = (p, pomin = []) => ZAP.filter((z) => !pomin.includes(z.nr)).map((z) => ({ z, s: punkty(z, p) })).sort((a, b) => b.s - a.s).filter((r) => r.s > -200);

  if (window.__VYD_TEST) window.__VYD = { czytaj, ranking, punkty, SLOWNIK };

  /* ——— wiadomości ——— */
  let historia = []; // tylko dla opcjonalnego AI
  const przewin = () => { rozmowa.scrollTop = rozmowa.scrollHeight; };
  const dodajMsg = (html, kto) => {
    const el = document.createElement('div');
    el.className = `vyd-msg vyd-msg--${kto}`;
    el.innerHTML = html;
    rozmowa.appendChild(el);
    requestAnimationFrame(() => { el.classList.add('is-in'); przewin(); });
    return el;
  };
  const pisze = () => dodajMsg('<span class="vyd-pisze"><i></i><i></i><i></i></span>', 'bot');
  const bot = (html, opcje, czekaj = 520) => new Promise((ok) => {
    const p = pisze();
    setTimeout(() => {
      p.remove();
      const el = dodajMsg(html, 'bot');
      historia.push({ role: 'assistant', content: el.innerText.slice(0, 500) });
      if (opcje && opcje.length) {
        const box = document.createElement('div');
        box.className = 'vyd-opcje';
        box.innerHTML = opcje.map(([v, t]) => `<button type="button" class="vyd-opcja" data-v="${esc(v)}">${esc(t)}</button>`).join('');
        rozmowa.appendChild(box);
        requestAnimationFrame(() => { box.classList.add('is-in'); przewin(); });
      }
      ok(el);
    }, czekaj);
  });
  const ja = (t) => { dodajMsg(esc(t), 'ja'); historia.push({ role: 'user', content: t }); };
  const zablokujOpcje = () => rozmowa.querySelectorAll('.vyd-opcje').forEach((b) => b.classList.add('is-uzyte'));

  const karta = (z) => `
    <div class="vyd-karta">
      <a class="vyd-karta__foto" href="${esc(z.url)}"><img src="${esc(z.img)}" alt="${esc(z.nazwa)}" width="180" height="180" loading="lazy"></a>
      <div class="vyd-karta__opis">
        <span class="vyd-karta__nr">No. ${esc(z.nr)}</span>
        <strong>${esc(z.nazwa)}</strong>
        ${z.haslo ? `<p>${esc(z.haslo)}</p>` : ''}
        ${lista(z.styl).length ? `<span class="vyd-karta__styl">${lista(z.styl).map(esc).join(' · ')}</span>` : ''}
        <div class="vyd-karta__akcje">
          ${z.dostepny === false ? '<span class="vyd-karta__brak">Chwilowo niedostępny</span>' : `<button type="button" class="vyd-karta__kup" data-vyd-koszyk="${esc(z.id)}">Do koszyka · ${esc(z.cena)}</button>`}
          <a class="vyd-karta__zobacz" href="${esc(z.url)}">Zobacz</a>
        </div>
      </div>
    </div>`;
  const mini = (z) => `<button type="button" class="vyd-mini" data-vyd-pokaz="${esc(z.nr)}"><img src="${esc(z.img)}" alt="" width="44" height="44" loading="lazy"><span>No. ${esc(z.nr)} <b>${esc(z.nazwa)}</b></span></button>`;
  const MENU = [['dobierz', 'Dobierz mi zapach'], ['coto', 'Czym są perfumy w kostce?'], ['uzycie', 'Jak ich używać?'], ['dostawa', 'Dostawa i zwroty']];
  const POPRAW = [['r:slodszy', 'Słodszy'], ['r:swiezszy', 'Świeższy'], ['r:mocniejszy', 'Mocniejszy'], ['r:delikatniejszy', 'Delikatniejszy'], ['r:inny', 'Pokaż inny']];

  // dlaczego ten zapach — z danych, bez wymyślania
  const powod = (z, p) => {
    const styl = lista(z.styl).filter((s) => !/męski|damski|unisex/i.test(s)).slice(0, 2).map((s) => s.toLowerCase());
    const traf = [];
    const klucz = (f) => bez(f).slice(0, 5);
    (p.nuty || []).filter((n) => !n.neg).forEach((n) => SLOWNIK.get(z.nr).forEach(([w, , fraza]) => { if (podobne(n.s, w) && !traf.some((x) => klucz(x) === klucz(fraza))) traf.push(fraza); }));
    const naz = `<b>No. ${esc(z.nr)} ${esc(z.nazwa)}</b>`;
    let txt = `${naz}${styl.length ? ` — ${esc(styl.join(' i '))}` : ''}.`;
    txt += traf.length ? ` Masz w nim to, czego szukasz: ${esc(traf.slice(0, 3).join(', '))}.` : ` W nutach: ${esc(nuty(z).slice(0, 4).join(', '))}.`;
    if (lista(z.okazje).length) txt += ` Okazje: ${esc(lista(z.okazje).slice(0, 3).map((o) => o.toLowerCase()).join(', '))}.`;
    return txt;
  };

  /* ——— przebieg: 3 pytania ——— */
  const PYTANIA = [
    { klucz: 'okazja', q: 'Na jaką okazję szukasz zapachu?', opcje: [['randka', 'Randka'], ['praca', 'Praca / ważne spotkanie'], ['impreza', 'Impreza / klub'], ['wesele', 'Wesele / wyjątkowa okazja'], ['wakacje', 'Wakacje / lato'], ['codzien', 'Na co dzień'], ['prezent', 'Na prezent']] },
    { klucz: 'klimat', q: 'Jaki klimat lubisz najbardziej?', opcje: [['slodki', 'Słodki, otulający'], ['swiezy', 'Świeży, lekki'], ['drzewny', 'Drzewny, dymny'], ['owocowy', 'Owocowy'], ['obojetny', 'Nie wiem — zaskocz mnie']] },
    { klucz: 'dla', q: 'Dla kogo?', opcje: [['m', 'Dla niego'], ['f', 'Dla niej'], ['u', 'Bez znaczenia']] },
  ];
  let pamiec = null, pokazane = [], krok = -1, odp = {};
  const naPref = (o) => ({ okazja: o.okazja, dla: o.dla, pora: o.pora, klimat: o.klimat && o.klimat !== 'obojetny' ? { [o.klimat]: 1 } : {}, nuty: [] });
  const pytaj = async () => {
    while (krok < PYTANIA.length && odp[PYTANIA[krok].klucz]) krok += 1;
    if (krok >= PYTANIA.length) { krok = -1; pamiec = naPref(odp); pokazane = []; return polec(); }
    const q = PYTANIA[krok];
    await bot(esc(q.q), q.opcje);
  };
  const zacznijDobor = (start = {}) => { odp = { ...start }; krok = 0; pytaj(); };

  // polecenie wg pamięci (preferencji); wstep = zdanie przed kartą
  const polec = async (wstep) => {
    const r = ranking(pamiec, pokazane);
    if (!r.length) { pokazane = []; return bot('Pokazałem już wszystkie pasujące. Zacznijmy od nowa?', [['dobierz', 'Dobierz od nowa'], ['menu', 'Mam pytanie']]); }
    const naj = r[0].z;
    pokazane.push(naj.nr);
    await bot(`${wstep ? esc(wstep) + ' ' : ''}${wstep && wstep.endsWith(':') ? '' : 'Stawiam na: '}${powod(naj, pamiec)}${karta(naj)}`, null, 650);
    const alt = r.slice(1, 3).map((x) => x.z);
    if (alt.length) await bot(`Pasują też:<div class="vyd-minis">${alt.map(mini).join('')}</div>`, POPRAW, 380);
    else await bot('Chcesz coś zmienić?', POPRAW, 300);
  };
  const popraw = (v) => {
    if (!pamiec) pamiec = { klimat: {}, nuty: [] };
    pamiec.klimat = { ...(pamiec.klimat || {}) };
    // prośba o zmianę waży podwójnie i zawsze pokazuje inny zapach niż ostatni
    if (v === 'slodszy') { pamiec.klimat.slodki = 2; delete pamiec.klimat.swiezy; }
    if (v === 'swiezszy') { pamiec.klimat.swiezy = 2; delete pamiec.klimat.slodki; delete pamiec.klimat.cieply; }
    if (v === 'mocniejszy') { pamiec.klimat.mocny = 2; delete pamiec.klimat.delikatny; }
    if (v === 'delikatniejszy') { pamiec.klimat.delikatny = 2; delete pamiec.klimat.mocny; }
    const CECHA = { slodszy: ['slodycz', 1], swiezszy: ['swiezosc', 1], mocniejszy: ['wyrazistosc', 1], delikatniejszy: ['wyrazistosc', -1] }[v];
    const ost = ZAP.find((x) => x.nr === pokazane[pokazane.length - 1]);
    pamiec.wzgledem = CECHA && ost ? { cecha: CECHA[0], kier: CECHA[1], od: (ost.profil || {})[CECHA[0]] || 0 } : null;
    if (v !== 'inny') pokazane = pokazane.slice(-1);
    return polec(CECHA && ost ? `${{ slodszy: 'Słodszy', swiezszy: 'Świeższy', mocniejszy: 'Mocniejszy', delikatniejszy: 'Delikatniejszy' }[v]} niż ${ost.nazwa}:` : '');
  };

  const opisz = async (z) => {
    const n = z.nuty || {};
    await bot(`<b>No. ${esc(z.nr)} ${esc(z.nazwa)}</b> — ${esc(z.klimat || z.haslo || '')}<br><br>Głowa: ${esc(lista(n.gora).join(', '))}. Serce: ${esc(lista(n.serce).join(', '))}. Baza: ${esc(lista(n.baza).join(', '))}.${lista(z.okazje).length ? `<br>Okazje: ${esc(lista(z.okazje).map((o) => o.toLowerCase()).join(', '))}.` : ''}${karta(z)}`, null, 600);
    pamiec = { podobny: z.nr, klimat: {}, nuty: [], slowa: [] }; pokazane = [z.nr];
    return bot('Coś jeszcze?', [['r:inny', 'Pokaż podobny'], ['dobierz', 'Dobierz mi zapach'], ['menu', 'Mam pytanie']], 300);
  };
  const porownaj = async (a, b) => {
    const pa = a.profil || {}, pb = b.profil || {};
    const roznice = Object.entries(PROFIL).map(([k, nazwa]) => {
      if ((pa[k] || 0) === (pb[k] || 0)) return '';
      const w = (pa[k] || 0) > (pb[k] || 0) ? a : b;
      return `${nazwa}: więcej w ${w.nazwa} (${pa[k] || 0}/5 vs ${pb[k] || 0}/5)`;
    }).filter(Boolean);
    const linia = (z) => `<b>No. ${esc(z.nr)} ${esc(z.nazwa)}</b> — ${esc(z.haslo || '')} (${esc(lista(z.styl).map((s) => s.toLowerCase()).join(', '))}; ${esc(z.pora || '')})`;
    await bot(`${linia(a)}<br><br>${linia(b)}${roznice.length ? `<br><br>Różnice: ${esc(roznice.join('; '))}.` : ''}`, null, 650);
    await bot(karta(a), null, 250);
    await bot(karta(b), [['dobierz', 'Dobierz mi zapach'], ['menu', 'Mam pytanie']], 250);
  };
  const pokazFAQ = async (k) => {
    if (k === 'dostawa') { await bot(FAQ.dostawa, null); return bot(FAQ.zwroty, [['dobierz', 'Dobierz mi zapach'], ['menu', 'Inne pytanie']], 380); }
    if (k === 'trwalosc') {
      await bot(FAQ.trwalosc, null);
      pamiec = { klimat: { cieply: 1, mocny: 1 }, nuty: [] }; pokazane = [];
      return polec('Jeśli zależy ci na tym, żeby zapach był wyczuwalny dłużej, celuj w ciepłe i wyraziste kompozycje.');
    }
    return bot(FAQ[k], [['dobierz', 'Dobierz mi zapach'], ['menu', 'Inne pytanie']]);
  };

  /* ——— zrozumienie wiadomości ——— */
  const SLOWA = [
    [/dostaw|wysyl|kurier|paczkomat|przesyl|kiedy dojdzie|ile idzie/, 'dostawa'], [/zwrot|oddac|odstapi|reklamac|wymian/, 'dostawa'],
    [/gdzie (jest )?moj|status zamow|nr zamow|numer zamow|nie doszl|nie przyszl|zamowilem|zamowilam/, 'zamowienie'],
    [/jak (sie )?(uzyw|nakl|stosowa|nakada)|nakladac|nalozyc|psika/, 'uzycie'], [/trwal|jak dlugo|utrzymuj|najdluzej|trzyma sie|wytrzym/, 'trwalosc'],
    [/feromon/, 'feromony'], [/ile kosztuj|cena|koszt|za ile|drogi|drogie|tani|promoc|rabat|znizk/, 'cena'], [/co to (jest|sa)|czym sa|jak to dziala|w kostce|balsam|zamiast flakon/, 'coto'],
    [/ile (jest |macie )?zapach|wszystkie zapach|jakie macie/, 'ile'], [/najpopular|bestseller|najlepiej sie sprzed|najczesciej|hit/, 'popularny'],
  ];
  const POPRAWKI = [[/slodsz|bardziej slodk/, 'slodszy'], [/swiezsz|lzejsz|bardziej swiez/, 'swiezszy'], [/mocniejsz|wyrazistsz|intensywniejsz/, 'mocniejszy'],
    [/delikatniejsz|subtelniejsz|slabsz/, 'delikatniejszy'], [/\binny\b|cos innego|nastepn|jeszcze jak|kolejn|inna propozyc/, 'inny']];
  const nazwyW = (t) => {
    const traf = ZAP.filter((z) => t.includes(bez(z.nazwa)) || t.includes(bez(z.nazwa.split(/[\s&]+/)[0])) && z.nazwa.split(/[\s&]+/)[0].length > 4);
    const nr = [...t.matchAll(/(?:no|nr|numer|#)\.?\s?0?(\d{1,2})\b/g)].map((m) => String(m[1]).padStart(2, '0'));
    nr.forEach((n) => { const z = ZAP.find((x) => x.nr === n); if (z && !traf.includes(z)) traf.push(z); });
    return traf;
  };
  const rozum = async (tekst) => {
    const t = bez(tekst).trim(), tk = tokeny(tekst);
    if (!t) return;
    if (tk.length <= 3 && /^(czesc|hej|siema|witam|dzien dobry|dobry wieczor|elo|hello|hi)\b/.test(t)) return bot('Cześć! Powiedz, na jaką okazję szukasz zapachu albo jakie nuty lubisz — dobiorę coś dla ciebie.', MENU);
    if (tk.length <= 4 && /^(dzieki|dziekuje|dzieks|thx|super|ok|okej|spoko|git)\b/.test(t)) return bot('Proszę bardzo! Jakby co — jestem tutaj.', MENU);
    const nazwy = nazwyW(t);
    if (nazwy.length >= 2) return porownaj(nazwy[0], nazwy[1]);
    const p = czytaj(tekst);
    if (nazwy.length === 1) {
      if (/podobn|cos jak|w stylu|taki jak|jak .* ale/.test(t)) { pamiec = { podobny: nazwy[0].nr, klimat: p.klimat, nuty: [], slowa: [] }; pokazane = [nazwy[0].nr]; return polec(`Najbliżej ${nazwy[0].nazwa}:`); }
      return opisz(nazwy[0]);
    }
    const poprawka = znajdz(t, POPRAWKI);
    if (poprawka && pamiec) { if (p.dla) pamiec.dla = p.dla; if (p.okazja) pamiec.okazja = p.okazja; return popraw(poprawka); }
    const faq = znajdz(t, SLOWA);
    if (faq && (faq !== 'trwalosc' || !maSygnal(p))) return pokazFAQ(faq);
    if (maSygnal(p)) {
      // łączenie z tym, co już wiemy z rozmowy (np. najpierw „na randkę”, potem „dla niej”)
      // krótkie dopowiedzenie („dla niej”, „a na wieczór?”) łączy się z poprzednim pytaniem; nowe pełne pytanie zaczyna od zera
      const dopowiedzenie = pamiec && !pamiec.podobny && (tk.length <= 4 || /^(a|i|ale|oraz|tylko|to)\b/.test(t));
      const baza = dopowiedzenie ? pamiec : { klimat: {}, nuty: [], slowa: [] };
      pamiec = { okazja: p.okazja || baza.okazja, pora: p.pora || baza.pora, dla: p.dla || baza.dla, klimat: { ...(baza.klimat || {}), ...p.klimat },
        nuty: [...(baza.nuty || []).slice(-6), ...p.nuty], slowa: [...(baza.slowa || []).slice(-8), ...p.slowa] };
      pokazane = [];
      return polec();
    }
    if (poprawka) { pamiec = { klimat: {}, nuty: [] }; return popraw(poprawka); }
    if (AI) return doAI(tekst);
    return bot(`Nie jestem pewien, o co chodzi. Napisz np. „coś słodkiego na randkę”, „świeże na lato dla niej” albo nazwę zapachu. Możesz też <a href="${esc(D.kontakt)}">napisać do nas</a>.`, MENU);
  };
  const doAI = async (tekst) => {
    const p = pisze();
    try {
      const ctrl = new AbortController(); const stop = setTimeout(() => ctrl.abort(), 25000);
      const r = await fetch(AI, { method: 'POST', headers: { 'Content-Type': 'application/json' }, signal: ctrl.signal, body: JSON.stringify({ wiadomosci: historia.slice(-12), strona: location.pathname }) });
      clearTimeout(stop);
      if (!r.ok) throw new Error(String(r.status));
      const j = await r.json();
      p.remove();
      await bot(esc(j.odpowiedz || '').replace(/\n+/g, '<br>') || 'Spróbuj zapytać inaczej.', null, 80);
      const pol = lista(j.polecane).map((nr) => ZAP.find((z) => z.nr === String(nr).padStart(2, '0'))).filter(Boolean);
      for (const z of pol.slice(0, 2)) await bot(karta(z), null, 200);
    } catch (e) { p.remove(); return bot(`Nie jestem pewien, o co chodzi. Możesz <a href="${esc(D.kontakt)}">napisać do nas</a> albo wybrać:`, MENU); }
  };

  const wybierz = (v, tekst) => {
    zablokujOpcje();
    ja(tekst);
    if (krok >= 0 && PYTANIA[krok] && PYTANIA[krok].opcje.some(([x]) => x === v)) { odp[PYTANIA[krok].klucz] = v; krok += 1; return pytaj(); }
    if (v.startsWith('r:')) return popraw(v.slice(2));
    if (v === 'dobierz') return zacznijDobor();
    if (v === 'menu') return bot('O co chcesz zapytać? Możesz też po prostu napisać, czego szukasz.', MENU);
    if (FAQ[v] || v === 'trwalosc') return pokazFAQ(v);
    return bot('Wybierz jedną z opcji:', MENU);
  };

  /* ——— zdarzenia ——— */
  rozmowa.addEventListener('click', async (e) => {
    const o = e.target.closest('.vyd-opcja');
    if (o && !o.closest('.is-uzyte')) return wybierz(o.dataset.v, o.textContent);
    const m = e.target.closest('[data-vyd-pokaz]');
    if (m) { const z = ZAP.find((x) => x.nr === m.dataset.vydPokaz); if (z) { zablokujOpcje(); ja(`No. ${z.nr} ${z.nazwa}`); opisz(z); } return; }
    const k = e.target.closest('[data-vyd-koszyk]');
    if (k && !k.disabled) {
      zablokujOpcje();
      k.disabled = true; const stary = k.textContent; k.textContent = 'Dodaję…';
      try {
        const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(k.dataset.vydKoszyk), quantity: 1 }] }) });
        if (!r.ok) throw new Error();
        k.textContent = 'W koszyku ✓'; k.classList.add('is-ok');
        bot(`Dodane do koszyka. <a class="vyd-link" href="${esc(D.kasa)}">Przejdź do koszyka →</a>`, [['dobierz', 'Dobierz drugi zapach'], ['menu', 'Mam pytanie']], 350);
      } catch (err) { k.disabled = false; k.textContent = stary; bot('Nie udało się dodać do koszyka. Spróbuj na stronie zapachu.', null, 200); }
    }
  });
  pole.addEventListener('submit', (e) => {
    e.preventDefault();
    const t = input.value.trim();
    if (!t) return;
    input.value = '';
    zablokujOpcje();
    ja(t);
    if (krok >= 0 && PYTANIA[krok]) { // odpowiedź na bieżące pytanie wpisana słowami
      const q = PYTANIA[krok], b = bez(t);
      const v = q.klucz === 'okazja' ? znajdz(b, TAB.okazja) : q.klucz === 'dla' ? (znajdz(b, TAB.dla) || (/bez znacz|wszystk/.test(b) ? 'u' : null))
        : (znajdz(b, KLIMATY.filter(([, k]) => ['slodki', 'swiezy', 'drzewny', 'owocowy'].includes(k))) || (/nie wiem|zaskocz|obojet/.test(b) ? 'obojetny' : null));
      if (v) { odp[q.klucz] = v; krok += 1; return pytaj(); }
      krok = -1;
    }
    return rozum(t);
  });

  const otworz = (tak) => {
    root.classList.toggle('is-open', tak);
    okno.hidden = !tak;
    dymek.setAttribute('aria-expanded', String(tak));
    if (tak) {
      sesja.set('vyd-zajawka', '1'); root.classList.remove('has-zajawka');
      if (!rozmowa.children.length) bot('Cześć! Jestem doradcą VYBE. Napisz, na jaką okazję szukasz zapachu albo jakie nuty lubisz — albo wybierz poniżej.', MENU, 350);
      setTimeout(() => { if (window.matchMedia('(min-width: 700px)').matches) input.focus(); }, 250);
    }
  };
  dymek.addEventListener('click', () => otworz(!root.classList.contains('is-open')));
  $('[data-vyd-zamknij]').addEventListener('click', () => { otworz(false); dymek.focus(); });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && root.classList.contains('is-open')) otworz(false); });
  document.addEventListener('click', (e) => { const a = e.target.closest('a[href="#doradca"]'); if (a) { e.preventDefault(); otworz(true); } });
  if (!sesja.get('vyd-zajawka')) setTimeout(() => { if (!root.classList.contains('is-open')) { root.classList.add('has-zajawka'); sesja.set('vyd-zajawka', '1'); } }, 9000);
  if (root.dataset.produkt) {
    const lap = () => root.classList.toggle('nad-paskiem', !!document.querySelector('.vy-sticky.is-on'));
    new MutationObserver(lap).observe(document.body, { subtree: true, attributes: true, attributeFilter: ['class'] });
    lap();
  }
})();
